import { combineReducers } from '@reduxjs/toolkit';

import applicationReducer from './applicationReducer';
import userReducer from "./userReducer";
import customizationReducer from './customizationReducer';
import { accountDashboardReducer, memberDashboardReducer } from "./dashboardReducer";
import accountSummaryReducer from './accountSummaryReducer';
import accountHistoryReducer from './accountHistoryReducer';
import storageHistoryReducer from './storageHistoryReducer';

export const LOGOUT_ACTION = 'LOGOUT';

const rootReducer = combineReducers({
    application: applicationReducer,
    user: userReducer,
    customization: customizationReducer,
    accountDashboard: accountDashboardReducer,
    memberDashboard: memberDashboardReducer,
    accountSummary: accountSummaryReducer,
    accountHistory: accountHistoryReducer,
    storageHistory: storageHistoryReducer,
});

const reducer = (state, action) => {
    if (action.type === LOGOUT_ACTION) {
        return rootReducer({application: state.application}, action);
    }

    return rootReducer(state, action);
}

export default reducer;